export const MODAL_UPDATE_CREW_LOCATION_TEXT = {
	updateCrewLocationTitle: 'Update crew member’s location',
	updateCrewLocationDescription:
		'Select the crew member’s current location along with the date and time their availability became effective',
	confirmBtn: 'Confirm',
	cancelBtn: 'Cancel',
	dateAndTimeAvailability: 'Date and time of availability',
	selectLocation: 'Select location',
	dateAndTimeAvailabilityRequired: 'Date and time of availability is required',
	note: 'Note',
};
